/*
 * error-boundary
 */
import { Container, Header, Page } from "@timeprox/react/ui"
import { Component, ReactNode } from "react"

type ErrorBoundaryProps = {
	fallback?: ReactNode
	children: ReactNode
}

type ErrorBoundaryState = {
	error?: Error
	hasError: boolean
}

export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	state = {
		error: undefined,
		hasError: false,
	}
	static getDerivedStateFromError(error: any) {
		console.error("ROOT_getDerivedStateFromError", error)
		return { hasError: true, error }
	}

	componentDidCatch(error: Error, errorInfo: any) {
		console.error("ROOT_componentDidCatch", {
			error,
			errorInfo,
			state: this.state,
		})
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) {
				return this.props.fallback
			}
			const devMode = localStorage.getItem("dev-mode") === "true"
			return (
				<Page>
					<Container className={"justify-center align-center"} width={"xl"}>
						<Header className={"text-center"} size={"xs"}>
							Something went wrong
						</Header>
						<div className={"flex flex-row items-center justify-center gap-8"}>
							<a
								style={{ textDecoration: "underline" }}
								href={window.location.href}
							>
								Refresh
							</a>
							<a style={{ textDecoration: "underline" }} href={"/"}>
								Return Home
							</a>
						</div>
						{devMode && this.state.error && (
							<div
								className={
									"flex flex-col gap-4 items-center border border-destructive-600 bg-destructive text-destructive-foreground p-4 rounded"
								}
							>
								<span className={"font-bold text-md text-center"}>
									Error - {(this.state.error as Error).message}
								</span>
								<pre className={"whitespace-pre-wrap text-sm max-h-[400px]"}>
									{(this.state.error as Error).stack}
								</pre>
							</div>
						)}
					</Container>
				</Page>
			)
		}

		return this.props.children
	}
}
